import { Component, Input } from '@angular/core';
import { VisitorEvent } from '../../../models/visitor.event';

@Component({
  selector: 'ig-event-time',
  templateUrl: './event.time.component.html',
  styleUrls: ['./event.time.component.scss'],
})
export class EventTimeComponent {
  @Input() item: VisitorEvent;
  @Input() mode: 'one-line' | 'two-lines' = 'one-line';
}
